

const getOperationId = operationUrl => {
  const [ , operationId ] = operationUrl.split('/api/')
  return operationId
}

export default getOperationId
